import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteIcon from '@mui/icons-material/Delete';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import { videoDeleted, videoDownloaded } from 'features/videos/videosSlice';

export const handleEditItem  = (dispatch, navigate, enqueueSnackbar) => (event,item) => {
  navigate("/dashboard/videos/edit/" + item.id)
}

  // DELETE Video
  export const handleDeleteItem = (dispatch, navigate, enqueueSnackbar) => (event,item) => {

    event.stopPropagation();

    const confirm = window.confirm("Are you sure ?");

    if(confirm) dispatch(videoDeleted({videoId: item.id})).then(result => {

      result.type === "videos/videoDeleted/fulfilled"
                            ? enqueueSnackbar("Video deleted successfully")
                            : enqueueSnackbar("Video - " + result.error.message);
                });
}

  // DOWNLOAD Video
  export const handleDownloadItem = (dispatch, navigate, enqueueSnackbar) => (event,item) => {

    event.stopPropagation();
    
    
    dispatch(videoDownloaded(item)).then(result => {
      console.log(item.videoable_type.substring(4));
     if(result.type === "videos/downloadVideo/fulfilled"){
        let downloadLink = document.createElement("a");
        let fileExt = item.url.split(".")[1];
        let dataUrl = URL.createObjectURL(new Blob([result.payload], {type: "video/" + fileExt}));
        downloadLink.href = dataUrl;
        downloadLink.setAttribute('download', item.videoable_type.substring(4) + "Videos_" + item.id + "." + fileExt); 
        downloadLink.click(); 
        enqueueSnackbar(item.videoable_type.substring(4) + " Video downloaded successfully");
        URL.revokeObjectURL(dataUrl);
      } else {
        enqueueSnackbar("Video - " + result.error.message);
      } 
    });

  }

export const VideosActions = (dispatch, navigate, enqueueSnackbar) => [
  {
    id:1,
    name: "Download",
    icon: <ArrowCircleDownIcon  sx={{color: (theme) => theme.palette.primary.main }}/>,
    callback: handleDownloadItem(dispatch, navigate, enqueueSnackbar),
    show: true
    },
   {
    id:2,
    name: "Edit",
    icon: <ModeEditIcon  sx={{color: (theme) => theme.palette.primary.main }}/>,
    callback: handleEditItem(dispatch, navigate, enqueueSnackbar),
    show: true
    },
    {
      id:3,
      name: "Delete",
      icon: <DeleteIcon  sx={{color: (theme) => theme.palette.primary.main }}/>,
      callback: handleDeleteItem(dispatch, navigate, enqueueSnackbar),
      show: true
    },
  ];